var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAuthenticatorForAndroidIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 63,
    viewBox: "0 0 177 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.274414,
    width: 177,
    height: 62.5769,
    rx: 9.73399,
    fill: "#0B2443"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3256_1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6659 16.1197C17.2834 16.5052 17.0574 17.1034 17.0574 17.8781V45.5571C17.0574 46.3331 17.2834 46.9301 17.6659 47.3155L17.7631 47.4057L34.0457 31.9003V31.7176V31.5349L17.7631 16.0283L17.6659 16.1197Z",
    fill: "url(#paint0_linear_3256_1064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4721 37.0706L34.0454 31.9005V31.7178V31.5351L39.4734 26.3662L39.5956 26.4325L46.0264 29.9118C47.8624 30.9055 47.8624 32.5313 46.0264 33.5263L39.5956 37.0055L39.4721 37.0706Z",
    fill: "url(#paint1_linear_3256_1064)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3256_1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5961 37.0043L34.0446 31.7178L17.666 47.3157C18.2706 47.9265 19.2708 48.0015 20.3971 47.3933L39.5961 37.0043Z",
    fill: "url(#paint2_linear_3256_1064)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.5961 26.4314L20.3971 16.0437C19.2708 15.4342 18.2706 15.5105 17.666 16.1213L34.0459 31.7192L39.5961 26.4314Z",
    fill: "url(#paint3_linear_3256_1064)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.7007 33.2322C85.7812 33.2322 83.4016 35.3376 83.4016 38.2373C83.4016 41.1194 85.7812 43.2424 88.7007 43.2424C91.6215 43.2424 94.001 41.1194 94.001 38.2373C93.9998 35.3376 91.6202 33.2322 88.7007 33.2322ZM88.7007 41.2724C87.1007 41.2724 85.7216 40.0214 85.7216 38.2385C85.7216 36.4367 87.1019 35.2046 88.7007 35.2046C90.3007 35.2046 91.6798 36.4367 91.6798 38.2385C91.6798 40.0202 90.3007 41.2724 88.7007 41.2724ZM77.1393 33.2322C74.2198 33.2322 71.8402 35.3376 71.8402 38.2373C71.8402 41.1194 74.2198 43.2424 77.1393 43.2424C80.0601 43.2424 82.4396 41.1194 82.4396 38.2373C82.4396 35.3376 80.0601 33.2322 77.1393 33.2322ZM77.1393 41.2724C75.5393 41.2724 74.1602 40.0214 74.1602 38.2385C74.1602 36.4367 75.5405 35.2046 77.1393 35.2046C78.7393 35.2046 80.1184 36.4367 80.1184 38.2385C80.1196 40.0202 78.7393 41.2724 77.1393 41.2724ZM63.3882 34.7691V36.8922H68.7481C68.588 38.0867 68.1685 38.9587 67.528 39.5648C66.7484 40.3038 65.5282 41.1194 63.3882 41.1194C60.0889 41.1194 57.5095 38.5974 57.5095 35.4694C57.5095 32.3413 60.0889 29.8193 63.3882 29.8193C65.1683 29.8193 66.4679 30.4831 67.4274 31.3363L69.0076 29.8381C67.667 28.6248 65.8882 27.6963 63.3882 27.6963C58.8687 27.6963 55.0691 31.1845 55.0691 35.4694C55.0691 39.7543 58.8687 43.2424 63.3882 43.2424C65.8274 43.2424 67.6682 42.4834 69.1069 41.0617C70.5865 39.6589 71.047 37.6865 71.047 36.0943C71.047 35.6023 71.0073 35.1469 70.9266 34.768L63.3882 34.7691ZM119.629 36.4179C119.189 35.2999 117.849 33.2322 115.109 33.2322C112.39 33.2322 110.129 35.2611 110.129 38.2373C110.129 41.0429 112.37 43.2424 115.369 43.2424C117.788 43.2424 119.188 41.8396 119.769 41.0241L117.969 39.8861C117.37 40.7204 116.549 41.27 115.369 41.27C114.189 41.27 113.349 40.7581 112.809 39.7531L119.868 36.9851L119.629 36.4179ZM112.429 38.0867C112.37 36.1519 114.009 35.1669 115.19 35.1669C116.11 35.1669 116.889 35.6035 117.15 36.2284L112.429 38.0867ZM106.691 42.94H109.01V28.2282H106.691V42.94ZM102.89 34.3514H102.81C102.29 33.7629 101.29 33.2322 100.031 33.2322C97.391 33.2322 94.9717 35.4317 94.9717 38.2573C94.9717 41.0629 97.391 43.2436 100.031 43.2436C101.291 43.2436 102.29 42.7128 102.81 42.1068H102.89V42.827C102.89 44.7417 101.81 45.7656 100.071 45.7656C98.6509 45.7656 97.7708 44.7994 97.4109 43.9838L95.3913 44.7806C95.971 46.1069 97.5102 47.738 100.071 47.738C102.791 47.738 105.091 46.221 105.091 42.5234V33.537H102.891L102.89 34.3514ZM100.231 41.2724C98.6311 41.2724 97.2917 40.0014 97.2917 38.2573C97.2917 36.4932 98.6311 35.2046 100.231 35.2046C101.81 35.2046 103.05 36.4932 103.05 38.2573C103.05 40.0014 101.81 41.2724 100.231 41.2724ZM130.495 28.2282H124.945V42.94H127.26V37.3664H130.494C133.061 37.3664 135.586 35.6047 135.586 32.7979C135.586 29.9911 133.062 28.2282 130.495 28.2282ZM130.555 35.3187H127.26V30.2759H130.555C132.286 30.2759 133.269 31.6352 133.269 32.7979C133.269 33.9371 132.286 35.3187 130.555 35.3187ZM144.869 33.2063C143.192 33.2063 141.456 33.9065 140.737 35.4588L142.793 36.272C143.232 35.4588 144.051 35.1928 144.909 35.1928C146.107 35.1928 147.325 35.8742 147.344 37.0852V37.237C146.925 37.0098 146.026 36.6697 144.929 36.6697C142.713 36.6697 140.456 37.8242 140.456 39.9814C140.456 41.9502 142.274 43.2177 144.309 43.2177C145.866 43.2177 146.725 42.5551 147.264 41.7784H147.343V42.9141H149.58V37.2735C149.581 34.6632 147.523 33.2063 144.869 33.2063ZM144.589 41.2689C143.832 41.2689 142.773 40.9087 142.773 40.019C142.773 38.8834 144.091 38.4479 145.229 38.4479C146.246 38.4479 146.726 38.6563 147.344 38.9399C147.164 40.3038 145.927 41.2689 144.589 41.2689ZM157.725 33.5276L155.07 39.9061H154.991L152.235 33.5276H149.74L153.872 42.4422L151.516 47.4014H153.932L160.301 33.5276H157.725ZM136.864 42.94H139.179V28.2282H136.864V42.94Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0991 19.5264C63.0991 20.4947 62.7916 21.2654 62.1752 21.8409C61.4757 22.5249 60.5629 22.867 59.4418 22.867C58.3678 22.867 57.4538 22.5203 56.7035 21.827C55.9519 21.1325 55.5762 20.2728 55.5762 19.2467C55.5762 18.2195 55.9519 17.3597 56.7035 16.6664C57.4538 15.972 58.3678 15.6253 59.4418 15.6253C59.9751 15.6253 60.4848 15.7224 60.9685 15.9153C61.4534 16.1095 61.8416 16.3672 62.1318 16.6895L61.4782 17.2997C60.9858 16.7508 60.3075 16.4769 59.4406 16.4769C58.6568 16.4769 57.9796 16.7335 57.4079 17.2465C56.8362 17.7596 56.551 18.4263 56.551 19.2456C56.551 20.0648 56.8362 20.7316 57.4079 21.2446C57.9796 21.7577 58.6568 22.0142 59.4406 22.0142C60.2715 22.0142 60.9648 21.7565 61.5191 21.24C61.8788 20.9037 62.0871 20.4358 62.1429 19.836H59.4406V19.0029H63.0458C63.083 19.1843 63.0991 19.3588 63.0991 19.5264Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8165 16.6307H65.4283V18.8285H68.4841V19.6616H65.4283V21.8594H68.8165V22.7122H64.4721V15.7791H68.8165V16.6307Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8482 22.7122H71.892V16.6307H69.8134V15.7791H74.9267V16.6307H72.8482V22.7122Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6261 22.7122V15.7791H79.5823V22.7122H78.6261Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8227 22.7122H82.8665V16.6307H80.788V15.7791H85.9012V16.6307H83.8227V22.7122Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5806 21.8167C94.8489 22.5169 93.9398 22.867 92.8522 22.867C91.7645 22.867 90.8555 22.5169 90.125 21.8167C89.3933 21.1164 89.0287 20.259 89.0287 19.2456C89.0287 18.2322 89.3933 17.3748 90.125 16.6746C90.8555 15.9743 91.7645 15.623 92.8522 15.623C93.9336 15.623 94.8414 15.9755 95.5756 16.6792C96.3098 17.3829 96.6769 18.238 96.6769 19.2456C96.6769 20.259 96.311 21.1164 95.5806 21.8167ZM90.8307 21.2354C91.3813 21.7554 92.0547 22.0143 92.8522 22.0143C93.6496 22.0143 94.3243 21.7543 94.8737 21.2354C95.4243 20.7154 95.7009 20.0522 95.7009 19.2456C95.7009 18.4391 95.4243 17.7758 94.8737 17.2558C94.3243 16.7358 93.6496 16.477 92.8522 16.477C92.0547 16.477 91.3813 16.737 90.8307 17.2558C90.2813 17.7758 90.0047 18.4391 90.0047 19.2456C90.0047 20.0522 90.2813 20.7154 90.8307 21.2354Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0188 22.7122V15.7791H99.1821L102.798 21.1719H102.839L102.798 19.8361V15.7791H103.755V22.7122H102.756L98.9725 17.0571H98.9316L98.9725 18.3928V22.7122H98.0188Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0991 19.5264C63.0991 20.4947 62.7916 21.2654 62.1752 21.8409C61.4757 22.5249 60.5629 22.867 59.4418 22.867C58.3678 22.867 57.4538 22.5203 56.7035 21.827C55.9519 21.1325 55.5762 20.2728 55.5762 19.2467C55.5762 18.2195 55.9519 17.3597 56.7035 16.6664C57.4538 15.972 58.3678 15.6253 59.4418 15.6253C59.9751 15.6253 60.4848 15.7224 60.9685 15.9153C61.4534 16.1095 61.8416 16.3672 62.1318 16.6895L61.4782 17.2997C60.9858 16.7508 60.3075 16.4769 59.4406 16.4769C58.6568 16.4769 57.9796 16.7335 57.4079 17.2465C56.8362 17.7596 56.551 18.4263 56.551 19.2456C56.551 20.0648 56.8362 20.7316 57.4079 21.2446C57.9796 21.7577 58.6568 22.0142 59.4406 22.0142C60.2715 22.0142 60.9648 21.7565 61.5191 21.24C61.8788 20.9037 62.0871 20.4358 62.1429 19.836H59.4406V19.0029H63.0458C63.083 19.1843 63.0991 19.3588 63.0991 19.5264Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8165 16.6307H65.4283V18.8285H68.4841V19.6616H65.4283V21.8594H68.8165V22.7122H64.4721V15.7791H68.8165V16.6307Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8482 22.7122H71.892V16.6307H69.8134V15.7791H74.9267V16.6307H72.8482V22.7122Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6261 22.7122V15.7791H79.5823V22.7122H78.6261Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8227 22.7122H82.8665V16.6307H80.788V15.7791H85.9012V16.6307H83.8227V22.7122Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5806 21.8167C94.8489 22.5169 93.9398 22.867 92.8522 22.867C91.7645 22.867 90.8555 22.5169 90.125 21.8167C89.3933 21.1164 89.0287 20.259 89.0287 19.2456C89.0287 18.2322 89.3933 17.3748 90.125 16.6746C90.8555 15.9743 91.7645 15.623 92.8522 15.623C93.9336 15.623 94.8414 15.9755 95.5756 16.6792C96.3098 17.3829 96.6769 18.238 96.6769 19.2456C96.6769 20.259 96.311 21.1164 95.5806 21.8167ZM90.8307 21.2354C91.3813 21.7554 92.0547 22.0143 92.8522 22.0143C93.6496 22.0143 94.3243 21.7543 94.8737 21.2354C95.4243 20.7154 95.7009 20.0522 95.7009 19.2456C95.7009 18.4391 95.4243 17.7758 94.8737 17.2558C94.3243 16.7358 93.6496 16.477 92.8522 16.477C92.0547 16.477 91.3813 16.737 90.8307 17.2558C90.2813 17.7758 90.0047 18.4391 90.0047 19.2456C90.0047 20.0522 90.2813 20.7154 90.8307 21.2354Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0188 22.7122V15.7791H99.1821L102.798 21.1719H102.839L102.798 19.8361V15.7791H103.755V22.7122H102.756L98.9725 17.0571H98.9316L98.9725 18.3928V22.7122H98.0188Z",
    stroke: "white",
    strokeWidth: 0.0497678,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3256_1064",
    x: 17.0574,
    y: 15.623,
    width: 30.3459,
    height: 32.1904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.193463
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3256_1064"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.193463
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3256_1064",
    result: "effect2_innerShadow_3256_1064"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3256_1064",
    x: 17.666,
    y: 31.7178,
    width: 21.9302,
    height: 16.0957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.193463
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3256_1064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3256_1064",
    x1: 32.6024,
    y1: 17.5852,
    x2: 11.6242,
    y2: 39.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3256_1064",
    x1: 48.4164,
    y1: 31.7178,
    x2: 16.6162,
    y2: 31.7178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3256_1064",
    x1: 36.5813,
    y1: 34.5887,
    x2: 8.13215,
    y2: 64.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3256_1064",
    x1: 13.541,
    y1: 6.90717,
    x2: 26.2443,
    y2: 20.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticatorForAndroidIconsvg);
export default __webpack_public_path__ + "static/media/Google_Authenticator_for_Android_icon.svg.5e8755bfeb5e2aecd9053ccd2e9a610a.svg";
export { ForwardRef as ReactComponent };